import { render, staticRenderFns } from "./sided-title-text.vue?vue&type=template&id=705fd53a&scoped=true"
import script from "./sided-title-text.vue?vue&type=script&lang=js"
export * from "./sided-title-text.vue?vue&type=script&lang=js"
import style0 from "./sided-title-text.vue?vue&type=style&index=0&id=705fd53a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705fd53a",
  null
  
)

export default component.exports